import { render, staticRenderFns } from "./InternationalDeliveryOrderToBeReviewed.vue?vue&type=template&id=5f3f0a3c&scoped=true"
import script from "./InternationalDeliveryOrderToBeReviewed.vue?vue&type=script&lang=js"
export * from "./InternationalDeliveryOrderToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./InternationalDeliveryOrderToBeReviewed.vue?vue&type=style&index=0&id=5f3f0a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f0a3c",
  null
  
)

export default component.exports